type Props = {
  collapsed?: boolean;
};

export default function ExpenseIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.25 15.6887H11.25M0.75 14.1949H6.75M17.25 12.7012H11.25M3.75 11.1949V17.1949M6.75 3.69495H0.75M16.5 1.44495L12 5.94495M16.5 5.94495L12 1.44495"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
